import { type AxiosRequestConfig } from 'axios'

import { useMutator as useOrvalMutator } from '@dhl/orval'

export const useMutator = <T>(baseUrl = ''): ((config: AxiosRequestConfig) => Promise<T>) => {
  const mutator = useOrvalMutator({
    baseURL: baseUrl,
  })

  return (config: AxiosRequestConfig) => mutator(config) as Promise<T>
}
